export interface IssuingBody {
    id: string;
    name: string;
}

export const issuingBodies: IssuingBody[] = [
    { id: 'ABNC', name: 'ABNC - Academia Brasileira de Neurocirurgia' },
    { id: 'AGU', name: 'AGU - Advocacia-Geral da União' },
    { id: 'ANAC', name: 'ANAC - Agência Nacional de Aviação Civil' },
    { id: 'CAER', name: 'CAER - Clube de Aeronáutica' },
    { id: 'CAU', name: 'CAU - Conselho de Arquitetura e Urbanismo' },
    { id: 'CBM', name: 'CBM - Corpo de Bombeiro Militar' },
    { id: 'CFA', name: 'CFA - Conselho Federal Administração' },
    { id: 'CFB', name: 'CFB - Conselho Federal de Biblioteconomia' },
    { id: 'CFBIO', name: 'CFBIO - Conselho Federal de Biologia' },
    { id: 'CFBM', name: 'CFBM - Conselho Federal de Biomedicina' },
    { id: 'CFC', name: 'CFC - Conselho Federal de Contabilidade' },
    { id: 'CFESS', name: 'CFESS - Conselho Federal de Serviço Social' },
    { id: 'CFF', name: 'CFF - Conselho Regional de Farmácia' },
    { id: 'CFFA', name: 'CFFA - Conselho Federal de Fonoaudiologia' },
    { id: 'CFM', name: 'CFM - Conselho Federal de Medicina' },
    { id: 'CFMV', name: 'CFMV - Conselho Federal de Medicina Veterinária' },
    { id: 'CFN', name: 'CFN - Conselho Federal de Nutrição' },
    { id: 'CFO', name: 'CFO - Conselho Federal de Odontologia' },
    { id: 'CFP', name: 'CFP - Conselho Federal de Psicologia' },
    { id: 'CFQ', name: 'CFQ - Conselho Regional de Química' },
    { id: 'CFT', name: 'CFT - Conselho Federal dos Técnicos Industriais' },
    { id: 'CFTA', name: 'CFTA - Conselho Federal dos Técnicos Agrícolas' },
    { id: 'CGPI', name: 'CGPI - Coordenação Geral de Privilégios e Imunidades' },
    { id: 'CGPMAF', name: 'CGPMAF - Coordenadoria Geral de Polícia Marítima, Aeronáutica e de Fronteiras' },
    { id: 'CIPC', name: 'CIPC - Centro de Inteligência da Polícia Civil' },
    { id: 'CNIG', name: 'CNIG - Conselho Nacional de Imigração' },
    { id: 'CNT', name: 'CNT - Confederação Nacional do Transporte' },
    { id: 'CNTV', name: 'CNTV - Confederação Nacional de Vigilantes & Prestadores de Serviços' },
    { id: 'COFECI', name: 'COFECI - Conselho Federal de Corretores de Imóveis' },
    { id: 'COFECON', name: 'COFECON - Conselho Federal de Economia' },
    { id: 'COFEM', name: 'COFEM - Conselho Federal de Museologia' },
    { id: 'COFEN', name: 'COFEN - Conselho Federal de Enfermagem' },
    { id: 'COFFITO', name: 'COFFITO - Conselho Regional de Fisioterapia e Terapia Ocupacional' },
    { id: 'COMAER', name: 'COMAER - Comando da Aeronáutica' },
    { id: 'CONFE', name: 'CONFE - Conselho Federal de Estatística' },
    { id: 'CONFEA', name: 'CONFEA - Conselho Federal de Engenharia e Agronomia' },
    { id: 'CONFEF', name: 'CONFEF - Conselho Federal de Educação Física' },
    { id: 'CONFERE', name: 'CONFERE - Conselho Federal dos Representantes Comerciais' },
    { id: 'CONRE', name: 'CONRE - Conselho Regional de Estatística' },
    { id: 'CONRERP', name: 'CONRERP - Conselho Federal de Profissionais de Relações Públicas' },
    { id: 'CORE', name: 'CORE - Conselho Regional dos Representantes Comerciais' },
    { id: 'CORECON', name: 'CORECON - Conselho Regional de Economia' },
    { id: 'COREM', name: 'COREM - Conselho Regional de Museologia' },
    { id: 'COREN', name: 'COREN - Conselho Regional de Enfermagem' },
    { id: 'CRA', name: 'CRA - Conselho Regional de Administração' },
    { id: 'CRAS', name: 'CRAS - Centro de Referência de Assistência Social' },
    { id: 'CRB', name: 'CRB - Conselho Regional de Biblioteconomia' },
    { id: 'CRBIO', name: 'CRBIO - Conselho Regional de Biologia' },
    { id: 'CRBM', name: 'CRBM - Conselho Regional de Biomedicina' },
    { id: 'CRC', name: 'CRC - Conselho Regional de Contabilidade' },
    { id: 'CREA', name: 'CREA - Conselho Regional de Engenharia e Agronomia' },
    { id: 'CRECI', name: 'CRECI - Conselho Regional de Corretores de Imóveis' },
    { id: 'CREF', name: 'CREF - Conselho Regional de Educação Física' },
    { id: 'CREFITO', name: 'CREFITO - Conselho Regional de Fisioterapia e Terapia Ocupacional' },
    { id: 'CRESS', name: 'CRESS - Conselho Regional de Serviço Social' },
    { id: 'CRF', name: 'CRF - Conselho Regional de Farmácia' },
    { id: 'CRFA', name: 'CRFA - Conselho Regional de Fonoaudiologia' },
    { id: 'CRM', name: 'CRM - Conselho Regional de Medicina' },
    { id: 'CRMV', name: 'CRMV - Conselho Regional de Medicina Veterinária' },
    { id: 'CRN', name: 'CRN - Conselho Regional de Nutrição' },
    { id: 'CRO', name: 'CRO - Conselho Regional de Odontologia' },
    { id: 'CRP', name: 'CRP - Conselho Regional de Psicologia' },
    { id: 'CRPRE', name: 'CRPRE - Conselho Regional de Profissionais de Relações Públicas' },
    { id: 'CRQ', name: 'CRQ - Conselho Regional de Química' },
    { id: 'CRT', name: 'CRT - Conselho Regional dos Técnicos Industriais' },
    { id: 'CRTA', name: 'CRTA - Conselho Regional de Técnicos de Administração' },
    { id: 'CTPS', name: 'CTPS - Carteira de Trabalho e Previdência Social' },
    { id: 'CV', name: 'CV - Cartório Civil' },
    { id: 'DELEMIG', name: 'DELEMIG - Delegacia de Polícia de Imigração' },
    { id: 'DETRAN', name: 'DETRAN - Departamento Estadual de Trânsito' },
    { id: 'DGPC', name: 'DGPC - Diretoria Geral da Polícia Civil' },
    { id: 'DIC', name: 'DIC - Diretoria de Identificação Civil' },
    { id: 'DICC', name: 'DICC - Diretoria de Identificação Civil e Criminal' },
    { id: 'DIREX', name: 'DIREX - Diretoria Executiva' },
    { id: 'DPF', name: 'DPF - Departamento de Polícia Federal' },
    { id: 'DPMAF', name: 'DPMAF - Divisão de Polícia Marítima, Aérea e de Fronteiras' },
    { id: 'DPT', name: 'DPT - Departamento de Polícia Técnica Geral' },
    { id: 'DPTC', name: 'DPTC - Departamento de Polícia Técnico Científica' },
    { id: 'DREX', name: 'DREX - Delegacia Regional Executiva' },
    { id: 'DRT', name: 'DRT - Delegacia Regional do Trabalho' },
    { id: 'EB', name: 'EB - Exército Brasileiro' },
    { id: 'FAB', name: 'FAB - Força Aérea Brasileira' },
    { id: 'FENAJ', name: 'FENAJ - Federação Nacional dos Jornalistas' },
    { id: 'FGTS', name: 'FGTS - Fundo de Garantia do Tempo de Serviço' },
    { id: 'FIPE', name: 'FIPE - Fundação Instituto de Pesquisas Econômicas' },
    { id: 'FLS', name: 'FLS - Fundação Lyndolpho Silva' },
    { id: 'FUNAI', name: 'FUNAI - Fundação Nacional do Índio' },
    { id: 'GEJSP', name: 'GEJSP - Gerência de Estado de Justiça, Segurança Pública e Cidadania' },
    { id: 'GEJSPC', name: 'GEJSPC - Gerência de Estado de Justiça, Segurança Pública e Cidadania' },
    { id: 'GEJUSPC', name: 'GEJUSPC - Gerência de Estado de Justiça, Segurança Pública e Cidadania' },
    { id: 'GESP', name: 'GESP - Gerência de Estado de Segurança Pública' },
    { id: 'GOVGO', name: 'GOVGO - Governo do Estado de Goiás' },
    { id: 'I CLA', name: 'I CLA - Carteira de Identidade Classista' },
    { id: 'ICP', name: 'ICP - Instituto de Polícia Científica' },
    { id: 'IDAMP', name: 'IDAMP - Instituto de Identificação Dr. Aroldo Mendes Paiva' },
    { id: 'IFP', name: 'IFP - Instituto Félix Pacheco' },
    { id: 'IGP', name: 'IGP - Instituto Geral de Perícias' },
    { id: 'IIACM', name: 'IIACM - Instituto de Identificação Aderson Conceição de Melo' },
    { id: 'IICC', name: 'IICC - Instituto de Identificação Civil e Criminal' },
    { id: 'IICCECF', name: 'IICCECF - Instituto de Identificação Civil e Criminal Engrácia da Costa Francisco' },
    { id: 'IICM', name: 'IICM - Instituto de Identificação Carlos Menezes' },
    { id: 'IIGP', name: 'IIGP - Instituto de Identificação Gonçalo Pereira' },
    { id: 'IIJDM', name: 'IIJDM - Instituto de Identificação João de Deus Martins' },
    { id: 'IIPC', name: 'IIPC - Instituto de Identificação da Polícia Civil' },
    { id: 'IIRGD', name: 'IIRGD - Instituto de Identificação Ricardo Gumbleton Daunt' },
    { id: 'IIRHM', name: 'IIRHM - Instituto de Identificação Raimundo Hermínio de Melo' },
    { id: 'IITB', name: 'IITB - Instituto de Identificação Tavares Buril' },
    { id: 'IML', name: 'IML - Instituto Médico-Legal' },
    { id: 'INI', name: 'INI - Instituto Nacional de Identificação' },
    { id: 'IPF', name: 'IPF - Instituto Pereira Faustino' },
    { id: 'ITCP', name: 'ITCP - Instituto Técnico-Científico de Perícia' },
    { id: 'ITEP', name: 'ITEP - Instituto Técnico-Científico de Perícia' },
    { id: 'MAER', name: 'MAER - Ministério da Aeronáutica' },
    { id: 'MB', name: 'MB - Marinha do Brasil' },
    { id: 'MD', name: 'MD - Ministério da Defesa' },
    { id: 'MDS', name: 'MDS - Ministério da Cidadania' },
    { id: 'MEC', name: 'MEC - Ministério da Educação e Cultura' },
    { id: 'MEX', name: 'MEX - Ministério do Exército' },
    { id: 'MINDEF', name: 'MINDEF - Ministério da Defesa' },
    { id: 'MJ', name: 'MJ - Ministério da Justiça' },
    { id: 'MM', name: 'MM - Ministério da Marinha' },
    { id: 'MMA', name: 'MMA - Ministério da Marinha' },
    { id: 'MPAS', name: 'MPAS - Ministério da Previdência e Assistência Social' },
    { id: 'MPE', name: 'MPE - Ministério Público Estadual' },
    { id: 'MPF', name: 'MPF - Ministério Público Federal' },
    { id: 'MPT', name: 'MPT - Ministério Público do Trabalho' },
    { id: 'MRE', name: 'MRE - Ministério das Relações Exteriores' },
    { id: 'MT', name: 'MT - Ministério do Trabalho' },
    { id: 'MTE', name: 'MTE - Ministério da Economia' },
    { id: 'MTPS', name: 'MTPS - Ministério do Trabalho e Previdência Social' },
    { id: 'NUMIG', name: 'NUMIG - Núcleo de Polícia de Imigração' },
    { id: 'OAB', name: 'OAB - Ordem dos Advogados do Brasil' },
    { id: 'OMB', name: 'OMB - Ordens dos Músicos do Brasil' },
    { id: 'PC', name: 'PC - Polícia Civil' },
    { id: 'PF', name: 'PF - Polícia Federal' },
    { id: 'PGFN', name: 'PGFN - Procuradoria Geral da Fazenda Nacional' },
    { id: 'PM', name: 'PM - Polícia Militar' },
    { id: 'POLITEC', name: 'POLITEC - Perícia Oficial e Identificação Técnica' },
    { id: 'PRF', name: 'PRF - Polícia Rodoviária Federal' },
    { id: 'PTC', name: 'PTC - Polícia Tecnico-Científica' },
    { id: 'SCC', name: 'SCC - Secretaria de Estado da Casa Civil' },
    { id: 'SCJDS', name: 'SCJDS - Secretaria Coordenadora de Justiça e Defesa Social' },
    { id: 'SDS', name: 'SDS - Secretaria de Defesa Social' },
    { id: 'SECC', name: 'SECC - Secretaria de Estado da Casa Civil' },
    { id: 'SECCDE', name: 'SECCDE - Secretaria de Estado da Casa Civil e Desenvolvimento Econômico' },
    { id: 'SEDS', name: 'SEDS - Secretaria de Estado da Defesa Social' },
    { id: 'SEGUP', name: 'SEGUP - Secretaria de Estado da Segurança Pública e da Defesa Social' },
    { id: 'SEJSP', name: 'SEJSP - Secretaria de Estado de Justiça e Segurança Pública' },
    { id: 'SEJUC', name: 'SEJUC - Secretaria de Estado da Justica' },
    { id: 'SEJUSP', name: 'SEJUSP - Secretaria de Estado de Justiça e Segurança Pública' },
    { id: 'SEPC', name: 'SEPC - Secretaria de Estado da Polícia Civil' },
    { id: 'SEPOL', name: 'SEPOL - Secretaria de Estado de Polícia Civil' },
    { id: 'SES', name: 'SES - Secretaria de Estado da Segurança' },
    { id: 'SESC', name: 'SESC - Secretaria de Estado da Segurança e Cidadania' },
    { id: 'SESDC', name: 'SESDC - Secretaria de Estado da Segurança, Defesa e Cidadania' },
    { id: 'SESDEC', name: 'SESDEC - Secretaria de Estado da Segurança, Defesa e Cidadania' },
    { id: 'SESEG', name: 'SESEG - Secretaria Estadual de Segurança' },
    { id: 'SESP', name: 'SESP - Secretaria de Estado da Segurança Pública' },
    { id: 'SESPAP', name: 'SESPAP - Secretaria de Estado da Segurança Pública e Administração Penitenciária' },
    { id: 'SESPDC', name: 'SESPDC - Secretaria de Estado de Segurança Publica e Defesa do Cidadão' },
    { id: 'SESPDS', name: 'SESPDS - Secretaria de Estado de Segurança Pública e Defesa Social' },
    { id: 'SGPC', name: 'SGPC - Superintendência Geral de Polícia Civil' },
    { id: 'SGPJ', name: 'SGPJ - Superintendência Geral de Polícia Judiciária' },
    { id: 'SIM', name: 'SIM - Serviço de Identificação da Marinha' },
    { id: 'SJ', name: 'SJ - Secretaria da Justiça' },
    { id: 'SJCDH', name: 'SJCDH - Secretaria da Justiça e dos Direitos Humanos' },
    { id: 'SJDS', name: 'SJDS - Secretaria Coordenadora de Justiça e Defesa Social' },
    { id: 'SJS', name: 'SJS - Secretaria da Justiça e Segurança' },
    { id: 'SJTC', name: 'SJTC - Secretaria da Justiça do Trabalho e Cidadania' },
    { id: 'SJTS', name: 'SJTS - Secretaria da Justiça do Trabalho e Segurança' },
    { id: 'SNJ', name: 'SNJ - Secretaria Nacional de Justiça / Departamento de Estrangeiros' },
    { id: 'SPMAF', name: 'SPMAF - Serviço de Polícia Marítima, Aérea e de Fronteiras' },
    { id: 'SPTC', name: 'SPTC - Secretaria de Polícia Técnico-Científica' },
    { id: 'SRDPF', name: 'SRDPF - Superintendência Regional do Departamento de Polícia Federal' },
    { id: 'SRF', name: 'SRF - Receita Federal' },
    { id: 'SRTE', name: 'SRTE - Superintendência Regional do Trabalho' },
    { id: 'SSDC', name: 'SSDC - Secretaria da Segurança, Defesa e Cidadania' },
    { id: 'SSDS', name: 'SSDS - Secretaria da Segurança e da Defesa Social' },
    { id: 'SSI', name: 'SSI - Secretaria de Segurança e Informações' },
    { id: 'SSP', name: 'SSP - Secretaria de Segurança Pública' },
    { id: 'SSPCGP', name: 'SSPCGP - Secretaria de Segurança Pública e Coordenadoria Geral de Perícias' },
    { id: 'SSPDC', name: 'SSPDC - Secretaria de Segurança Pública e Defesa do Cidadão' },
    { id: 'SSPDS', name: 'SSPDS - Secretaria de Segurança Pública e Defesa Social' },
    { id: 'SSPPC', name: 'SSPPC - Secretaria de Segurança Pública Polícia Civil' },
    { id: 'SUSEP', name: 'SUSEP - Superintendência de Seguros Privados' },
    { id: 'SUSEPE', name: 'SUSEPE - Superintendência dos Serviços Penitenciários' },
    { id: 'TJ', name: 'TJ - Tribunal de Justiça' },
    { id: 'TJAEM', name: 'TJAEM - Tribunal Arbitral e Mediação dos Estados Brasileiros' },
    { id: 'TRE', name: 'TRE - Tribunal Regional Eleitoral' },
    { id: 'TRF', name: 'TRF - Tribunal Regional Federal' },
    { id: 'TSE', name: 'TSE - Tribunal Superior Eleitoral' },
    { id: 'XXX', name: 'XXX - Orgão Estrangeiro' },
    { id: 'ZZZ', name: 'ZZZ - Outro' },
]; 